import script from "./Welcome.vue?vue&type=script&setup=true&lang=ts"
export * from "./Welcome.vue?vue&type=script&setup=true&lang=ts"

export default script